<!--
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-12-17 16:25:30
-->
<template>
  <div>
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>{{ $t("route.disinfectionManage") }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t("route.disinfectionRecord") }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="contentWrapper disinfectList">
      <el-form ref="searchForm" :model="formInline" class="demo-form-inline">
        <el-form-item prop="disinfectStart">
          <el-date-picker
            v-model="formInline.disinfectStart"
            type="date"
            placeholder="开始消毒时间"
            :disabled-date="disabledDate"
            style="width: 210px"
          />
        </el-form-item>
        <el-form-item prop="sn">
          <el-select
            v-model="formInline.sn"
            placeholder="被消毒设备编码"
            style="width: 210px;margin: 0 24px"
          >
            <el-option
              v-for="item in robotList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="searchBtn">
          <el-button type="primary" size="medium" @click="handleSearch">{{ $t('system.search') }}</el-button>
          <el-button
            size="medium"
            @click="resetForm('searchForm')"
            style="margin-left: 24px"
          >{{ $t('system.reset') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        @row-click="goTaskInfo"
        :row-class-name="tableRowClassName"
        style="width: 100%;"
      >
        <el-table-column prop="deviceSn" label="被消毒设备编码" />
        <el-table-column prop="disinfectStart" label="开始消毒" />
        <el-table-column prop="disinfectEnd" label="结束消毒" />
        <el-table-column prop="disinfectTime" label="消毒总时长" >
				 <template #default="{row}">{{ !row.disinfectTime || row.disinfectTime == 0 ? '--' : getHM(row.disinfectTime) }}</template>
        </el-table-column>
        <el-table-column prop="robohubSn" label="消毒仓编码" />
        <template #empty>
          <div class="tableNodata">
            <img :src="totalImg.nodata" />
            <p>暂无数据</p>
          </div>
        </template>
      </el-table>
      <el-pagination
        background
        v-show="total != 0"
        :page-size="formInline.pageSize"
        :total="total"
        :current-page="formInline.page"
        :page-sizes="[12, 24, 48, 96, 200]"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, prev, pager, next, sizes, jumper"
        class="pagination"
      />
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  watch,
  ref,
  nextTick,
  toRefs,
  unref
} from "vue";
import moment from "moment";
import { useRouter, useRoute } from "vue-router";
import { ElMessageBox, ElMessage, ElForm } from "element-plus";
import { totalImg, getHM } from "@/utils/robot";
import { disinfectList, warehouseList, snList } from "@/apis/disinfect";
import i18n from "@/locales/index";
const _t = i18n.global.t;
export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const searchForm = ref(ElForm);
    const state = reactive({
      formInline: {
        disinfectStart: "",
        sn: "",
        pageSize: 12,
        page: 1
      },
      robotList: [],
			totalImg: totalImg(),
			// getHM: getHM(),
      total: 0,
      page: 1,
			tableData: [],
			getHM(value) {
      if (value == 0) { return value}
				let _h = value/3600
				const tempTime = moment.duration(value, 's');
				const h = tempTime.hours() ? Math.floor(_h) + 'h' : ''
				const m = tempTime.minutes() ? tempTime.minutes() + 'min' : ''
				const t = tempTime.seconds() ? tempTime.seconds() + 's' : ''
				return h + m + t;
			},
      getList() {
        disinfectList(state.formInline).then(res => {
          if (res.code == 200) {
						if (res.data) {
							state.tableData = res.data.robohubDisinfectInfoVOList;
            	state.total = res.data.total;
						}
          } else {
            ElMessage.closeAll();
            ElMessage({
              type: "error",
              message: res.msg
            });
          }
        });
			},
			getRobotList() {
				snList().then(res => {
					state.robotList = res.data
        });
			},
      handleSearch() {
        const time = state.formInline.disinfectStart;
        if (time) {
          state.formInline.disinfectStart = moment(time).format("YYYY-MM-DD");
        }
        state.getList();
      },
      resetForm(formName) {
        const form = unref(searchForm);
        form.resetFields();
        state.disinfectStatus = "";
        state.formInline.page = 1;
        state.getList();
      },
      disabledDate(time) {
        return time.getTime() > Date.now();
      },
      handleCurrentChange(page) {
        if(page) {
          state.formInline.page = page;
          state.getList();
        }
      },
      handleSizeChange(val) {
        state.formInline.pageSize = val;
        state.getList();
      }
    });
    onMounted(() => {
			if (route.params && route.params.sn) {
        state.formInline.sn = route.params.sn;
			}
			state.getList()
			state.getRobotList()
    });
    return {
      ...toRefs(state),
      searchForm,
      moment
    };
  }
};
</script>
<style lang="scss">
.disinfectList {
  .el-form-item {
    display: inline-block;
  }
  .has-gutter th {
    background: #fafafa;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
	.el-table__body-wrapper {
		min-height: 50vh;
	}
}
</style>
<style lang="scss" scoped>
.disinfectList {
  position: relative;
  h3 {
    margin: 0 0 16px;
  }
  .searchBtn {
    .openText {
      margin-left: 24px;
      // color: #409eff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>
